import React from 'react';
import { Link } from 'react-router-dom';

function Eroare404() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">
      <h1 className="text-9xl font-black text-blue-600 mb-4">404</h1>
      <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">Hopa! Pagina nu a fost gasita.</h2>
      <p className="text-gray-500 mb-8 text-center max-w-md text-lg">
        Se pare ca link-ul pe care l-ai accesat este gresit sau anuntul a fost sters intre timp de catre proprietar.
      </p>
      <Link 
        to="/" 
        className="bg-blue-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition shadow-lg shadow-blue-200"
      >
        Inapoi la Prima Pagina
      </Link>
    </div>
  );
}

export default Eroare404;